import { ACTIONS } from './connectionUtils'
import { insertProduct, type product } from './productUtils'

interface shoppingListProduct {
  id?: number
  product: number
  product_name?: string
  pack?: number
  quantity: number
  default_shop?: string
  shop: string
}

interface ShoppingListResponse {
  success: boolean
  results?: shoppingListProduct[]
  error?: string
}

async function getShoppingList(user: string): Promise<ShoppingListResponse> {
  try {
    const response = await fetch('/api/shoppingList', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.GET,
        user,
      }),
    })
    const data: ShoppingListResponse = await response.json()
    return data
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function insertNewProduct(user: string, product: shoppingListProduct) {
  try {
    const response = await fetch('/api/shoppingList', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.INSERT,
        user,
        product,
      }),
    })
    const data: ShoppingListResponse = await response.json()
    return data
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function completeProduct(user: string, product: shoppingListProduct) {
  try {
    const response = await fetch('/api/shoppingList', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.COMPLETE,
        user,
        product,
      }),
    })
    const data: ShoppingListResponse = await response.json()
    return data
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function updateProduct(user: string, product: shoppingListProduct) {
  try {
    const response = await fetch('/api/shoppingList', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.UPDATE,
        user,
        product,
      }),
    })
    const data: ShoppingListResponse = await response.json()
    return data
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function createDefaultProduct(
  user: string,
  productName: string,
  shop: string
) {
  const product: product = {
    name: productName,
    shop: shop,
    ingredient: 0,
    storable: 0,
    pack: 1,
  }
  return insertProduct(user, product)
}

export {
  getShoppingList,
  insertNewProduct,
  completeProduct,
  updateProduct,
  createDefaultProduct,
}

export type { shoppingListProduct }
